import axios from "@common/utils/ajax";

var consumerId = sessionStorage.getItem('companyId')
var userId = sessionStorage.getItem('userId')

export function get_exhibit_fields(params) {
    // /backend/v1/exhibit/detail/{id}
    return axios.post(`/cg/${consumerId}/match/${userId}/v1/queryRegistration/`, params).then(res => res.data)
}

export function get_exhibit_field_value(params) {
    return axios.post(`/cg/${consumerId}/match/${userId}/v1/querySupplierById/`, params).then(res => res.data)
}

export function post_update_exhibit_value(params) {
    return axios.post(`/api3/backend/v1/exhibit/update/${params.id}`, params).then(res => res.data)
}
export function post_add_exhibit_value(params) {
    return axios.post(`/api3/backend/v1/exhibit/add/${params.supplierId}`, params.exhibit).then(res => res.data)
}


// WEBPACK FOOTER //
// ./src/admin/components/organizer/toExhibitsDetail/api.js